import { type MRT_TableOptions } from "material-react-table";

import { ConfigurationTableRow } from "@plansoft-configuration-renderer/configuration-api";
import {
  useCsAttribute,
  useSyncInfo,
} from "@plansoft-configuration-renderer/framework";

export function useTableControlReadonlyOptions(): Partial<
  MRT_TableOptions<ConfigurationTableRow>
> {
  const { isSyncing } = useSyncInfo();
  const attribute = useCsAttribute();

  const disabled = attribute.isReadOnly || isSyncing;

  return {
    muiSelectCheckboxProps: {
      disabled,
    },
    muiSelectAllCheckboxProps: {
      disabled,
    },
  };
}
